import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { CommonService } from './common.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard  {
	constructor(
		private apiService: ApiService,
		private router: Router,
		private commonService: CommonService) { }
	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if(state.url == '/dashboard'){
			let rtqEmail = sessionStorage.getItem("rtq_redirect");
			if(rtqEmail){
				this.commonService.logOut();
				return;
			}
		}
		let token = this.apiService.getToken(),isAuthenticated;
		if (!token) {
			// Preserve the FCM intent through login + MFA — login-form keys off
			// ?state=fcm to set redirect_to_state, and CommonService.returnLastSavedState
			// brings the user back to /fcm after auth succeeds (CUX-1841).
			if (state.url && state.url.startsWith('/fcm')) {
				this.router.navigate(['/login'], { queryParams: { state: 'fcm' } });
			} else {
				this.router.navigate(['/login']);
			}
			isAuthenticated = false;
		}else{
			isAuthenticated = true;
		}
		return isAuthenticated;
	}

}
